import constants from '@helpers/Constants'
import axios from 'axios'

const geocoderURL = constants.geocoderURL
const request = axios.create({
  baseURL: geocoderURL
})

export const geocoder = {
  // search: (query) => {
  //   return request.get(`search?q=${query}&format=json`)
  // },
  search: (city: string, country?: string) => {
    let url = `search?city=${city}`

    if (country) {
      url += `&countrycodes=${country}`
    }

    url += '&format=json'
    return request.get(url)
  },

  reverse: (lat: string | number, lon: string | number) => {
    return request.get(`reverse?lat=${lat}&lon=${lon}&format=json`)
  },

  lookup: (id: string | number) => {
    return request.post(`lookup?osm_ids=${id}&format=json`)
  }
}
